import React from 'react'

// This will be displayed when the application is loading something

export default function Loading() {
	return (
		<div>
			Loading...
		</div>
	)
}
